import LogoutIcon from '@mui/icons-material/Logout';
import { Box, styled } from '@mui/system';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const LogoutIconStyled = styled(LogoutIcon)(({ theme }) => ({
  color: theme.palette.error.light,
  width: '1.125rem',
  display: 'flex',
  justifyContent: 'right',
  cursor: 'pointer',
}));

export const LogoutContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  color: theme.palette.error.light,
  gap: '0.5rem',
  padding: '0 2rem',
}));
